module.exports = __webpack_public_path__ + "static/media/MouthBeat Grooves.88053667.jpg";